import { Component, OnInit, Input, Output , EventEmitter } from '@angular/core';
import { Course } from 'src/app/models/course.model';


@Component({
  selector: 'app-course-item',
  templateUrl: './course-item.component.html',
  styleUrls: ['./course-item.component.css']
})
export class CourseItemComponent implements OnInit {

  @Input() hidePrice:boolean = false;
  @Input() course:Course;
  @Output() routeToCourseDetail:EventEmitter<string> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  onRouteToDetail(id:string){
    this.routeToCourseDetail.emit(id);
  }

}

